export default __webpack_public_path__ + "static/media/safe-recommendations--mobile.6e8972c5.webp";